<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { exchangeCdk } from '@/api'

const cdk = ref('')
const exchange = () => {
  if (!cdk.value) {
    ElMessage.error('请输入CDK！')
    return
  }
  exchangeCdk({ cdkCode: cdk.value, source: 10 }).then((res) => {
    if (res.code === 200) {
      ElMessage.success('登录成功！')
    }
  })
}
</script>
<template>
  <div class="background">
    <div class="box">
      <div class="text1">CDKEY兑换</div>
      <div class="text2">CDKEY兑换免费时长</div>
      <div class="text3">
        CDKEY是由18位字符组成的序列码，输入正确可点击【兑换】获得免费时长，每个CDK限领一次
      </div>
      <span>
        <el-input v-model="cdk" class="cdkinput" size="large" placeholder="请输入CDKEY编码" />
        <el-button size="large" class="btn" type="success" @click="exchange">兑 换</el-button>
      </span>
    </div>
  </div>
</template>
<style lang="less" scoped>
.background {
  width: 100%;
  background-color: #1f2322;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 96px 0 58px 0;
  min-height: calc(100vh - 308px);
  .box {
    background-color: #282C2B;
    color: #fff;
    padding: 32px 16px;
    width: 343px;

    .text1 {
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
    }

    .text2 {
      margin: 16px 0 12px 0;
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }

    .text3 {
      margin-bottom: 24px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 17px;
    }

    .btn {
      width: 311px;
      background: linear-gradient(90deg, #00ddd5 0%, #00bdcb 100%);
      margin-top: 32px;
      border: none;border-radius: 20px;
      color: #fff;

      &:hover {
        filter: brightness(0.9);
      }

      &:active {
        filter: brightness(0.8);
      }
    }
  }
}
</style>
<style lang="less">
.cdkinput {
  width: 311px;
}
</style>
